import { createContext } from 'react';
import { IVideoCategories } from 'types';

export type TVideoCategoriesSortBy = '' | 'NameA-Z' | 'NameZ-A';
export type TVideoCategoriesCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export interface IFilterValues {
	searchString: string;
	sortBy: TVideoCategoriesSortBy;
	countOfItems: TVideoCategoriesCountOfItems;
	currentPage: number;
}

export interface IVideoCategoriesState {
	videoCategories: IVideoCategories;
	searchString: string;
	sortBy: TVideoCategoriesSortBy;
	countOfItems: TVideoCategoriesCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const videoCategoriesInitialState: IVideoCategoriesState = {
	videoCategories: { videoCategoriesCount: 0, videoCategories: [] },
	searchString: '',
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	typeOfModalWindow: null,
};

export interface IVideoCategoriesContext extends IVideoCategoriesState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TVideoCategoriesSortBy): void;
	setCountOfItems(count: TVideoCategoriesCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const VideoCategoriesContext = createContext<IVideoCategoriesContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...videoCategoriesInitialState,
});
